var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9781 9.3586L15.7655 10.8364C15.3937 13.4203 15.2078 14.7123 14.3115 15.484C13.4151 16.2558 12.1006 16.2558 9.47164 16.2558H7.7842C5.15521 16.2558 3.8407 16.2558 2.94438 15.484C2.04804 14.7123 1.86214 13.4203 1.49035 10.8364L1.27771 9.3586C0.988274 7.34704 0.843557 6.34129 1.25582 5.48137C1.66807 4.62143 2.54556 4.09872 4.30053 3.05329L5.35688 2.42403C6.95057 1.47468 7.74743 1 8.62792 1C9.50841 1 10.3053 1.47468 11.8989 2.42403L12.9553 3.05329C14.7103 4.09872 15.5878 4.62143 16 5.48137",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.08661098387e69b1f929ef4da689d8be.svg";
export { ForwardRef as ReactComponent };